<template>
  <div>
    <vue-editor-clean-text :content.sync="editorContent" />

    <textarea
      v-show="false"
      v-model="editorContent"
      :name="inputName"
    />
  </div>
</template>

<script>
export default {
    name: 'BladeEditor',
    props:{
        inputName: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            editorContent: this.content,
        }
    },
}
</script>

<style scoped>

</style>
